<template>
  <div id="app" style="padding-bottom: 4rem">
    <main-nav v-if="userLoggedInStatus && showNav"></main-nav>
    <router-view style="margin-top: 40px"></router-view>
    <alert-alert />
  </div>
</template>

<script>
import MainNav from '@/views/MainNav'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: { MainNav },
  computed: {
    ...mapState(['userLoggedInStatus', 'user']),
    showNav() {
      if (this.$route.name === 'ApplicationReportDetail') {
        return false
      } else {
        return true
      }
    },
  },
  // async created() {
  //   // Always fetch fresh user profile data
  //   await this.$store.dispatch('refreshCurrentUser')

  //   // Check whether to force logout due to bad app state.
  //   const loggedOut = await this.$store.dispatch('checkShouldLogOut', { route: this.$route })

  //   if (loggedOut) {
  //     this.$router.replace({
  //       name: 'Login',
  //       query: { next: this.$route.path },
  //     })
  //   }
  // },
}
</script>

<style lang="scss">
// Import custom fonts
@import url('https://fonts.googleapis.com/css2?family=Poppins&display=swap');

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
    'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif, 'Poppins';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

// Import Bulma's core
@import '~bulma/sass/utilities/_all';

// Set your colors
$primary: #eb4b1b;
$primary-invert: findColorInvert($primary);

$warning: #ebb31b;
$warning-invert: findColorInvert($warning);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  'white': (
    $white,
    $black,
  ),
  'black': (
    $black,
    $white,
  ),
  'light': (
    $light,
    $light-invert,
  ),
  'dark': (
    $dark,
    $dark-invert,
  ),
  'primary': (
    $primary,
    $primary-invert,
  ),
  'info': (
    $info,
    $info-invert,
  ),
  'success': (
    $success,
    $success-invert,
  ),
  'warning': (
    $warning,
    $warning-invert,
  ),
  'danger': (
    $danger,
    $danger-invert,
  ),
);

$column-gap: 3.5rem;
// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import '~bulma';
// Import font awesome
$fa-font-path: '~font-awesome/fonts/';
@import '~font-awesome/scss/font-awesome';

// global custom styles

a {
  color: #000000;
}

h1 h2 h3 h4 h5 h6 {
  margin: 1.5rem 0;
}

// hide progress bars
.progress {
  display: none;
}
</style>
